import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { getEnvironmentValues } from "@/config/environment";

const { Title, Text } = Typography;

const AppVersion = () => {
  const { t } = useTranslation();
  const { appVersion } = getEnvironmentValues();

  return (
    <div className="app-version">
      <Title level={4}>{t("global:appVersion")}</Title>
      <Text>{appVersion}</Text>
    </div>
  );
};

export default AppVersion;
